import { Component, ElementRef, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { AppService } from '../shared/service/app/app.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { toggleAnimation } from 'src/app/shared/animations';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
import moment from 'moment';
import { AuthService } from '../shared/service/auth/auth.service';
import { Subscription } from 'rxjs';
import { AvataresService } from '../shared/service/avatares/avatares.service';

@Component({
  moduleId: module.id,
  selector: 'header',
  templateUrl: './header.html',
  animations: [toggleAnimation],
})
export class HeaderComponent implements OnInit, OnDestroy {
  store: any;
  search = false;
  isAuthenticated = false;
  isMobileMenuOpen: boolean = false;
  isDropdownOpen: boolean = false;
  selectedAvatar: string | null = null;
  isDarkMode: boolean = false;
  isDisabled: boolean = true;
  private authSubscription: Subscription | undefined;
  private avatarSubscription: Subscription | undefined;

  constructor(
    public translate: TranslateService,
    public storeData: Store<any>, //manejar el estado global
    public router: Router,
    private appSetting: AppService,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private analitycs: AnalitycsService,
    private authService: AuthService,
    private avataresService: AvataresService,
  ) {
    localStorage.setItem('light', 'dark');
    this.storeData
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
      });
    this.initStore();
    // Inicializar el estado de autenticación
    // this.isAuthenticated = this.authService.isAuthenticated();
  }
  async initStore() {
    this.storeData
      .select((d) => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }

  async ngOnInit() {
    // this.analitycs.logEvent('inicializar_nav_header', {
    //   pantalla: 'header',
    //   accion: 'click',
    //   timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
    //   plataforma: 'web',
    // });

    // Suscribirse a los cambios del avatar seleccionado
    this.avatarSubscription = this.avataresService.getSelectedAvatar().subscribe((avatarUrl) => {
      this.selectedAvatar = avatarUrl;
    });

    // Suscribirse al estado de autenticación
    this.authSubscription = this.authService.isAuthenticated$.subscribe((status: boolean) => {
      //   console.log('Estado de autenticación cambiado:', status);
      this.isAuthenticated = status;
    });
    const storedAvatar = localStorage.getItem('selectedAvatar'); // Obtiene el avatar guardado
    if (storedAvatar) {
      this.selectedAvatar = storedAvatar; // Si existe, se lo asignamos
    } else {
      this.selectedAvatar = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVCSMkWaF4ReLMfiRu3NXk12zJikhfSx0bSQ&s'; // Opción predeterminada (Juan)
    }
    // this.setActiveDropdown();
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     this.setActiveDropdown();
    //   }
    // });
  }

  ngOnDestroy() {
    // Limpiar la suscripción cuando el componente se destruye
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
    if (this.avatarSubscription) {
      this.avatarSubscription.unsubscribe();
    }
  }

  //   setActiveDropdown() {
  //     this.analitycs.logEvent('active-dropdown-menu', {
  //       view: 'header',
  //       action: 'click',
  //       at: moment().format('YYYY-MM-DD HH:mm:ss'),
  //     });
  //     const selector = document.querySelector('ul.horizontal-menu a[routerLink="' + window.location.pathname + '"]');
  //     if (selector) {
  //       selector.classList.add('active');
  //       const all: any = document.querySelectorAll('ul.horizontal-menu .nav-link.active');
  //       for (let i = 0; i < all.length; i++) {
  //         all[0]?.classList.remove('active');
  //       }
  //       const ul: any = selector.closest('ul.sub-menu');
  //       if (ul) {
  //         let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link');
  //         if (ele) {
  //           ele = ele[0];
  //           setTimeout(() => {
  //             ele?.classList.add('active');
  //           });
  //         }
  //       }
  //     }
  //   }
  changeLanguage(item: any) {
    this.analitycs.logEvent('cambio_idioma_nav_header', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.translate.use(item.code);
    this.appSetting.toggleLanguage(item);
    if (this.store.locale?.toLowerCase() === 'ae') {
      this.storeData.dispatch({ type: 'toggleRTL', payload: 'rtl' });
    } else {
      this.storeData.dispatch({ type: 'toggleRTL', payload: 'ltr' });
    }
  }
  toggleDropdown(): void {
    this.analitycs.logEvent('toggle_menu_navegacion_principal', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });

    this.isDropdownOpen = !this.isDropdownOpen;
  }
  gotoHome() {
    this.analitycs.logEvent('ir_a_inicio_desde_header', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });

    this.router.navigate(['/']);
    this.toggleDropdown();
  }
  goToProfile() {
    this.analitycs.logEvent('ir_a_perfil_desde_header', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });

    this.router.navigate(['/profile']);
    this.toggleDropdown();
  }
  GoToLogin() {
    this.analitycs.logEvent('ir_a_login_desde_header', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.router.navigate(['/login']);
    this.toggleDropdown();
  }
  logout() {
    this.analitycs.logEvent('cerrar_sesion_desde_header', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
    });

    // Limpiar localStorage
    localStorage.clear();

    // Limpiar sessionStorage
    sessionStorage.clear();

    // Limpiar caché del navegador
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }

    // Limpiar cookies
    document.cookie.split(';').forEach((cookie) => {
      document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
    });

    // Actualizar el estado de autenticación
    this.authService.logout();

    // Cerrar el dropdown
    this.toggleDropdown();

    // Redirigir al login
    this.router.navigate(['/login']);
  }
  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }
  goToRegister() {
    this.analitycs.logEvent('ir_a_registro_de_usuario_desde_header', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.router.navigate(['/register']);
    this.toggleDropdown();
  }
  goToAssistance() {
    this.analitycs.logEvent('ir_a_asistencia_desde_header', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.router.navigate(['/assistant']);
    this.toggleDropdown();
  }
  gotoVehicle() {
    this.analitycs.logEvent('ir_a_vehiculo_desde_header', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
    });
    this.router.navigate(['/vehicle']);
    this.toggleDropdown();
  }
  goToCalendar() {
    this.analitycs.logEvent('ir_a_calendario_desde_header', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      platforma: 'web',
    });
    this.router.navigate(['/calendar']);
    this.toggleDropdown();
  }
  appDownload() {
    this.analitycs.logEvent('descarga_app', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });

    this.router.navigate(['/app-download']);
    this.toggleDropdown();
  }
  // Detectar clics fuera del dropdown
  @HostListener('document:click', ['$event.target'])
  onClickOutside(targetElement: HTMLElement): void {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.isDropdownOpen = false;
      this.isMobileMenuOpen = false;
    }
  }
  //   goTomanin() {
  //     this.router.navigate(['/register-main']);
  //   }
  gotoNotifications() {
    this.analitycs.logEvent('ir_a_notificaciones_desde_header', {
      pantalla: 'header',
      accion: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.router.navigate(['/notifications']);
    this.toggleDropdown();
  }
  gotoCommunity() {
    this.analitycs.logEvent('ir_a_comunidad_desde_header', {
      pantalla: 'header',
      accion: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.router.navigate(['/community']);
    this.toggleDropdown();
  }
  gotoWhatsapp() {
    this.analitycs.logEvent('ir_a_whatsapp_desde_header_soporte', {
      pantalla: 'header',
      accion: 'click',
      at: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    window.open('https://api.whatsapp.com/send/?phone=573243399281&text&type=phone_number&app_absent=0', '_blank');
  }
}
